import { render, staticRenderFns } from "./UnsavedChangesDialog.vue?vue&type=template&id=97ca999e&"
import script from "./UnsavedChangesDialog.vue?vue&type=script&lang=js&"
export * from "./UnsavedChangesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports